/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

export type PortfolioTaskStatus = typeof PortfolioTaskStatus[keyof typeof PortfolioTaskStatus];


export const PortfolioTaskStatus = {
  concept: 'concept',
  planned: 'planned',
  open: 'open',
  closed: 'closed',
} as const;
